module.exports = __webpack_public_path__ + "img/Ghana.985f0019.svg";